export const APT = {
  navAppointments: "nav-appointments",
  page: "appointments-page",
  title: "appointments-title",
  newBtn: "new-appointment-btn",
  table: "appointments-table",
  emptyState: "appointments-empty",
  loading: "appointments-loading",
  row: "appointment-row",
  editBtn: "appointment-edit-btn",
  formPage: "new-appointment-page",
  formTitle: "new-appointment-title",
  cancelBtn: "appointment-cancel-btn",
  saveBtn: "appointment-save-btn",
  saveNewBtn: "appointment-save-new-btn",
  saveCopyBtn: "appointment-save-copy-btn",
  saveEncounterBtn: "appointment-save-encounter-btn",
  patientSearch: "appointment-patient-search",
  patientResult: "appointment-patient-result",
  selectedPatient: "appointment-selected-patient",
  noShowRate: "appointment-no-show-rate",
  viewChart: "appointment-view-chart",
  visitType: "appointment-visit-type",
  encounterClass: "appointment-encounter-class",
  reason: "appointment-reason",
  referringProvider: "appointment-referring-provider",
  provider: "appointment-provider",
  resource: "appointment-resource",
  comment: "appointment-comment",
  date: "appointment-date",
  startTime: "appointment-start-time",
  duration: "appointment-duration",
  endTime: "appointment-end-time",
  repeat: "appointment-repeat",
  confirmation: "appointment-confirmation",
  reminderMethod: "appointment-reminder-method",
  reminderOffset: "appointment-reminder-offset",
  status: "appointment-status",
  patientInstruction: "appointment-patient-instruction",
  preview: "appointment-preview",
  officeLocation: "appointment-office-location",
  datePrev: "appointment-calendar-prev",
  dateNext: "appointment-calendar-next",
  dateToday: "appointment-calendar-today",
  datePicker: "appointment-calendar-date",
  locationFilter: "appointment-calendar-location",
  refreshBtn: "appointment-calendar-refresh",
  dayView: "appointment-calendar-day",
  weekView: "appointment-calendar-week",
  monthView: "appointment-calendar-month",
  legend: "appointment-calendar-legend",
  total: "appointment-calendar-total",
  detail: "appointment-detail",
  startEncounter: "appointment-start-encounter",
  openEncounter: "appointment-open-encounter",
  sendSms: "appointment-send-sms-btn",
  smsDialog: "appointment-sms-dialog",
  smsPatient: "appointment-sms-patient",
  smsDate: "appointment-sms-date",
  smsTime: "appointment-sms-time",
  smsMobile: "appointment-sms-mobile",
  smsMessage: "appointment-sms-message",
  smsCancel: "appointment-sms-cancel-btn",
  smsSend: "appointment-sms-send-btn",
  smsResult: "appointment-sms-result",
  smsSendDestination: "appointment-sms-send-destination",
  smsConsentStatus: "appointment-sms-consent-status",
};
